<template>
    <div>
        <template>
            <div class="page-top mb-1 mb-3 clearfix">
            </div>
            <table id="ReconTransactionTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Batch ID</th>
                        <th>Batch Name</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                edit_in_process_batch: null,
                update_batch_status : new Form({
                    id : ''
                }),
                isUpdating: false,
            };
        },
        methods: {
            callDataTable(){
                const inprocess_batch = this.edit_in_process_batch
                var that = this;
                that.ReconTransactionTable = $('#ReconTransactionTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "/api/listInProcessBatches",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                         "type": 'POST',
                        "data": {
                            "transactionSource": "FINCA"
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'companyName'},
                        {data: 'id'},
                        {data: 'name'},
                        {data: 'updated_at'},
                        {
                            data: 'id', sorting: false, render: function (data, type, full) {
                                var $url = '/reconBatchList/'+full['id'];
                                if (inprocess_batch === true) {
                                    return '<a href="javascript:void(0);" onclick="window.updateBatchStatus('+full.id+')" data-toggle="tooltip" data-placement="top" title="UpdateBatchStatus" class="btn btn-primary">Update Batch Status</a>';
                                } else {
                                    return 'N/A';
                                }
                            }
                        }
                    ],
                    "order": [[ 0, "desc" ]],
                    // "columnDefs": [{
                    //         className: "text-center",
                    //         "targets": [ 6 ]
                    //     }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
              $('#customSearch').on( 'keyup', function (e) {
                if (e.keyCode === 13) {
                  ReconTransactionTable.search(this.value).draw();
                }
              });
            },
            updateBatchStatus(id) {
                var that = this;

                // Prevent further clicks if already updating
                if (this.isUpdating) return;

                this.isUpdating = true; // Set updating state to true
                that.update_batch_status.id = id;

                // Disable the button in the DataTable
                const buttonSelector = `a[onclick="window.updateBatchStatus(${id})"]`;
                $(buttonSelector).prop('disabled', true);

                console.log(that.update_batch_status);
                that.update_batch_status.post('/api/updateBatchStatus')
                    .then(res => {
                        if (res.status == 200) {
                            that.showToastBox('success', 'Batch status has been updated!');
                            that.ReconTransactionTable.ajax.reload();
                        } else {
                            that.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        that.showAlertBox('error', 'Error to load data');
                    })
                    .finally(() => {
                        // Re-enable the button after the operation completes
                        $(buttonSelector).prop('disabled', false);
                        that.isUpdating = false; // Reset updating state
                    });
            },
        },
        mounted() {
            var gThat = this;
            this.$Progress.start();
            this.can('edit_in_process_batch').then(result => {
                if (result.edit_in_process_batch == true) {
                    this.edit_in_process_batch = true;
                    this.callDataTable();
                } else {
                    this.edit_in_process_batch = false;
                    this.callDataTable();
                }
            }).then(result => {
                if (this.edit_in_process_batch == true) {
                    this.callDataTable()
                    this.$Progress.finish();
                } else {
                    this.$Progress.finish();
                }
            });
            window.updateBatchStatus = function(id){
                gThat.updateBatchStatus(id);
            }

        },
    }
</script>
